
import { Component, Vue } from 'vue-property-decorator';
import { EventBus } from '@/helpers/EventBusHelper';
import { EventBusEvents } from '@/enums/global/EventBusEvents';

@Component({
    name: 'RecalculateInstructionsModal',
})
export default class RecalculateInstructionsModal extends Vue {
    private visible = false;

    private mounted() {
        EventBus.$on(EventBusEvents.openRecalculateInstructionsPopup, this.showModal);
    }

    private beforeDestroy() {
        EventBus.$off(EventBusEvents.openRecalculateInstructionsPopup, this.showModal);
    }

    private showModal() {
        this.visible = true;
    }
}
